export default __webpack_public_path__ + "static/media/pexels-icsa-1709003.4a2e5d03.jpg";